import { createRootRoute } from '@tanstack/react-router';
import { verifyServerSession } from '@/features/auth';
import { BootSplash, NotFoundPage, RootComponent } from './-rootComponents';

export const Route = createRootRoute({
  beforeLoad: () => verifyServerSession(),
  pendingComponent: BootSplash,
  pendingMs: 100,
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});
